import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

import Header from "./sections/Header";
import Footer from "./sections/Footer";
import HomePage from "./pages/HomePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import ScrollToTop from "./components/ScrollToTop";
import ProjectsPage from "./pages/ProjectsPage";
import IndoEropaProjectPage from "./pages/IndoEropaProjectPage";
import TwizelProjectPage from "./pages/TwizelProjectPage";
import "./styles/animations.css";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/indoeropa" element={<IndoEropaProjectPage />} />
        <Route path="/projects/twizel" element={<TwizelProjectPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route
          path="/terms-conditions"
          element={<TermsAndConditionsPage />}
        />
      </Routes>

      <Footer />

      <Analytics />
      <SpeedInsights />
    </Router>
  );
};

export default App;
